module.exports = __webpack_public_path__ + "img/7.6d7377d0.jpg";